import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import DeleteSelectedScreenshot from "../modals/DeleteSelectedScreenshot";
import ViewPicture from "../modals/ViewPicture";
import Download from "../modals/Download";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import useLangTranslation from "../../../customHooks/languageProvider";
import moment from "moment";
import { deleteGallery, getGalleryData } from "../../AxiosRtk/Gallery";
import { isEmpty } from "lodash";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import {
  formattedDateTime,
  handleDownloadClick,
  handleStartDateCommon
} from "../../../../utils/helper";
import GalleryFilter from "../modals/GalleryFilter";
import { Spinner } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import ViewVideo from "../modals/ViewVideo";
import Select from "react-select";
import useDurationOption from "../../../customHooks/durationOption";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const Gallery = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedItem, setSelectedItem] = useState({});
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [tabId, setTabId] = useState("allTab");
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);

  const [screenshotListData, setScreenshotListData] = useState([]);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { handleDeviceSelection } = useDashboardDataProvider();
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const [kidData, setKidData] = useState(false);
  const { getImage } = useKidListFunctionality();
  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const [selectToBeDeleted, setSelectToBeDeleted] = useState(0);

  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const itemsPerPage = 25;
  const [pageNumber, setPageNumber] = useState(1);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getLangTranslation } = useLangTranslation();
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [deviceOptions, setDeviceOptions] = useState([]);
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();

  const [filterData, setFilterData] = useState({
    selectedCategoryIds: [],
  });

  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  const [filteredListData, setFilteredListData] = useState([]);
  const [selectedScreenshots, setSelectedScreenshots] = useState([]);
  const [localListData, setLocalListData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [deletedSelectedModal, setDeletedSelectedModal] = useState(false);
  const [viewPictureModal, setViewPictureModal] = useState(false);
  const [viewVideoModal, setViewVideoModal] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const openDeletedSelected = () => {
    setDeletedSelectedModal(true);
  };
  const closeDeletedSelected = () => {
    setDeletedSelectedModal(false);
  };
  const openViewPicture = (item) => {
    const screenshotUrl = item?.imageUrl;
    setSelectedItem(screenshotUrl);

    setViewPictureModal(true);
  };

  const openViewVideo = (item) => {
    const screenshotUrl = item?.imageUrl;
    setSelectedItem(screenshotUrl);

    setViewVideoModal(true);
  };

  const closeViewPicture = () => {
    setViewPictureModal(false);
  };

  const closeViewVideo = () => {
    setViewVideoModal(false);
  };
  const openDownloadPicture = () => {
    setDownloadModal(true);
  };
  const closeDownloadPicture = () => {
    setDownloadModal(false);
  };
  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    setKidData(kidList?.find((item, index) => item.ID === selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  function getGalleryHistory() {
    if (selectedDeviceData && startDate) {
      const obj = {
        deviceId: selectedDeviceData?.ID,
        startDate: startDate,
        endDate: endDate,
        pageNo: pageNumber,
        itemsPerPage: itemsPerPage,
        isToBeDeletedSoon: selectToBeDeleted,
      };

      if (filterData?.selectedCategoryIds?.length > 0) {
        obj["isGalleryFilter"] = filterData?.selectedCategoryIds
          ?.join(",")
          ?.toString();
      }

      getGalleryData(obj)
        .then((res) => {
          if (pageNumber === 1) setScreenshotListData(res?.data?.result);
          else
            setScreenshotListData([
              ...screenshotListData,
              ...res?.data?.result,
            ]);
          setLocalListData(res?.data?.result);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  const fetchData = () => {
    setPageNumber(pageNumber + 1);
  };

  const handleDelete = async (type) => {
    if (!isEmpty(selectedScreenshots) || isSelectAll) {
      const payload = {
        deviceId: selectedDeviceData?.ID,
        isDeleteAll: isSelectAll,
        activityType: "GALLERY",
        galleryActivityId: selectedScreenshots.toString(),
        type: type,
      };

      try {
        const { data } = await deleteGallery(payload);
        if (data) {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: data?.message,
              message: data?.message,
            })
          );
          closeDeletedSelected();
          setSelectedScreenshots([]);
          getGalleryHistory();
        }
      } catch (error) {
        closeDeletedSelected();
        console.log(error);
      }
    }
  };

  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    setIsSelectAll(checked ? 1 : 0);
  };

  const handleSelectToBeDeletedCheckbox = () => {
    setSelectToBeDeleted((prevValue) => (prevValue === 0 ? 1 : 0));
  };

  const handleCheckboxChange = (galleryId) => {
    if (selectedScreenshots.includes(galleryId)) {
      setSelectedScreenshots(
        selectedScreenshots.filter((id) => id !== galleryId)
      );
    } else {
      setSelectedScreenshots([...selectedScreenshots, galleryId]);
    }
  };

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    if (pageNumber === 1) getGalleryHistory();
    else setPageNumber(1);
  }, [
    startDate,
    endDate,
    selectedDeviceData,
    selectToBeDeleted,
    filterData?.selectedCategoryIds,
  ]);

  useEffect(() => {
    getGalleryHistory();
  }, [pageNumber]);

  useEffect(() => {
    if (tabId === "allTab") {
      setFilteredListData(screenshotListData);
    }
    if (tabId === "picturesTab") {
      setFilteredListData(screenshotListData.filter((item) => item?.type === 1));
    }
    if (tabId === "videosTab") {
      setFilteredListData(screenshotListData.filter((item) => item?.type === 2));
    }
  }, [tabId, screenshotListData]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                        }`}
                    />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "GALLERY_MONITORING_HEADER_TITLE",
                      "Gallery monitoring"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img
                  src={getImage(kidData?.image, kidData?.gender)}
                  alt=""
                  className="img-fluid"
                  onError={(event) => {
                    event.target.onerror = null;
                    event.target.src = getImage("", kidData?.gender);
                  }}
                />
              </span>
              <div>
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "GALLERY_HISTORY_SELECT_DEVICE_TITLE",
                    "Select Device"
                  )}
                  options={deviceOptions.length > 0 ? deviceOptions : []}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value === selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                  styles={{
                    placeholder: (base) => ({
                      ...base,
                      marginBottom: selectedDeviceData ? '8px' : "0px", // Adjust this value as needed
                    }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="allTab"
            data-bs-toggle="tab"
            data-bs-target="#All"
            type="button"
            role="tab"
            aria-controls="All"
            aria-selected="false"
            onClick={() => setTabId("allTab")}
          >
            {getLangTranslation("GALLERY_HISTORY_TAB_ALL_TITLE", "All")}
          </button>
          <button
            className="nav-link"
            id="picturesTab"
            data-bs-toggle="tab"
            data-bs-target="#pictures"
            type="button"
            role="tab"
            aria-controls="pictures"
            aria-selected="true"
            onClick={() => setTabId("picturesTab")}
          >
            {getLangTranslation("GALLERY_HISTORY_TAB_PHOTOS_TITLE", "Photos")}
          </button>
          <button
            className="nav-link"
            id="videosTab"
            data-bs-toggle="tab"
            data-bs-target="#videos"
            type="button"
            role="tab"
            aria-controls="videos"
            aria-selected="true"
            onClick={() => setTabId("videosTab")}
          >
            {getLangTranslation("GALLERY_HISTORY_TAB_VIDEOS_TITLE", "Videos")}
          </button>
        </div>
      </nav>
      <div className="card border-0">
        <div className="card-body">
          <div className="tab-content" id="nav-tabContent">
            <>
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
                <div className="d-flex align-items-center flex-wrap gap-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      name="allSelect"
                      id="selectAll"
                      checked={isSelectAll}
                      onChange={handleSelectAllChange}
                    />
                    <label
                      className="form-check-label text-dark"
                      htmlFor="selectAll"
                    >
                      {getLangTranslation(
                        "GALLERY_HISTORY_SELECT_ALL",
                        "Select All"
                      )}
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      name="allSelect"
                      id="deletedSoon"
                      checked={selectToBeDeleted === 1}
                      onChange={handleSelectToBeDeletedCheckbox}
                    />
                    <label
                      className="form-check-label text-dark"
                      htmlFor="deletedSoon"
                    >
                      {getLangTranslation(
                        "GALLERY_HISTORY_SELECT_TO_BE_DELETED_SOON",
                        "Select to be deleted soon"
                      )}
                    </label>
                  </div>
                  <button
                    className="btn btn-outline-primary"
                    type="button"
                    onClick={openDeletedSelected}
                  >
                    {getLangTranslation(
                      "GALLERY_HISTORY_BUTTON_DELETE_SELECTED",
                      "Delete selected"
                    )}
                  </button>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
                  <DateFilter
                    startDate={startDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                    selectedDuration={selectedDuration}
                  />
                  <Select
                    className="custom-select col-lg-4"
                    classNamePrefix="custom-select"
                    placeholder="Select"
                    onChange={(val) => {
                      handleStartDateCommon(
                        val,
                        setStartDate,
                        setSelectedDuration,
                        setEndDate
                      );
                    }}
                    options={durationOptions}
                    value={
                      durationOptions?.find(
                        (item) => item?.value === selectedDuration
                      ) || ""
                    }
                  />
                  <span className="icon-wrap pt-cursor" onClick={openModal}>
                    <i className="icon-filter" />
                  </span>
                </div>
              </div>

              <InfiniteScroll
                dataLength={filteredListData?.length}
                scrollThreshold={0.5}
                next={fetchData}
                hasMore={localListData?.length > 0}
                loader={
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "1rem",
                    }}
                  >
                    <Spinner size="large" />
                  </p>
                }
                scrollableTarget="scrollablescrll"
                className="grid gap-6"
              >
                {filteredListData?.map((item, index) => (
                  <div className="g-col-12 g-col-md-6 g-col-lg-4">
                    <div className=" ratio ratio-5x3 mb-3">
                      {item?.type === 1 && (
                        <img
                          className="rounded-3 cursor-pointer"
                          src={item?.imageUrl}
                          alt="Image"
                          onClick={() => {
                            if (item?.type === 1) openViewPicture(item);
                            if (item?.type === 2) openViewVideo(item);
                          }}
                        />
                      )}
                      {item?.type == 2 && (
                        <video
                          className="rounded-3 cursor-pointer"
                          src={item?.imageUrl}
                          alt="Image"
                          onClick={() => {
                            if (item?.type === 1) openViewPicture(item);
                            if (item?.type === 2) openViewVideo(item);
                          }}
                        />
                      )}
                      <input
                        className="form-check-input top-0 start-100 mt-3"
                        style={{ marginLeft: "-2rem" }}
                        type="checkbox"
                        value=""
                        checked={selectedScreenshots.includes(item.galleryId)}
                        onChange={() => handleCheckboxChange(item.galleryId)}
                      />
                    </div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      {item?.type == 1 && (
                        <div className="icon-wrap bg-blue-50 border-0 ">
                          <i className="icon-placeholder text-blue-600" />
                        </div>
                      )}
                      {item?.type === 2 && (
                        <div className="icon-wrap bg-blue-50 border-0 ">
                          <i className="icon-video text-blue-600" />
                        </div>
                      )}
                      <div className="d-flex flex-column">
                        <h5 className="text-small text-blue-900 mb-1">
                          {item?.type === 1 && "Picture"}
                          {item?.type === 2 && "Video"}
                        </h5>
                        <span className="text-small">
                          {formattedDateTime(item?.activityDatetime)}
                        </span>
                      </div>
                      <div
                        className="icon-wrap bg-blue-50 border-0 ms-auto pt-cursor"
                        onClick={() =>
                          handleDownloadClick(item?.imageUrl)
                            .then((res) => {
                              openDownloadPicture();
                            })
                            .catch((error) => {
                              console.error("Download failed:", error);
                            })
                        }
                      >
                        <i className="icon-download text-blue-400 fs-5" />
                      </div>
                    </div>
                  </div>
                ))}
              </InfiniteScroll>

              <GalleryFilter
                showModal={showModal}
                closeModal={closeModal}
                filterData={filterData}
                setFilterData={setFilterData}
                getLangTranslation={getLangTranslation}
                selectedDeviceId={selectedDeviceData?.ID}
              />
              <DeleteSelectedScreenshot
                selectedDeviceId={selectedDeviceData?.ID}
                selectedScreenshots={selectedScreenshots}
                showModal={deletedSelectedModal}
                closeModal={closeDeletedSelected}
                handleDelete={handleDelete}
                getLangTranslation={getLangTranslation}
                isDeleteAllSelected={isSelectAll}
              />
              <ViewPicture
                showModal={viewPictureModal}
                closeModal={closeViewPicture}
                selectedItem={selectedItem}
                getLangTranslation={getLangTranslation}
              />
              <ViewVideo
                showModal={viewVideoModal}
                closeModal={closeViewVideo}
                selectedItem={selectedItem}
                getLangTranslation={getLangTranslation}
              />
              <Download
                showModal={downloadModal}
                closeModal={closeDownloadPicture}
                getLangTranslation={getLangTranslation}
              />
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
